// ==========================
// 非同期CSS読み込み完了後に is-loaded へ切替
// 旧: document.fonts.ready + 4000ms timeout → LCP 7.6s の主因
// 新: preload[as=style] の load イベント検知 → CSS適用後即時開放
//    font-display:optional のためフォントスワップなし → フォント待ち廃止
// ==========================
(function () {
  function releaseLock() {
    document.documentElement.classList.remove("is-loading");
    document.documentElement.classList.add("is-loaded");
    // スライダーフォールバック: slider.js は window.load 後に動的読み込みのため
    // PSI計測中は is-ready が付与されず .custom-slider が不可視のまま SI 悪化する。
    // 1.5s 後に未初期化スライダーを is-slider-disabled で表示し SI を改善する。
    // slider.js 初期化時に is-slider-disabled は自動除去・is-ready が付与される。
    setTimeout(function () {
      document.querySelectorAll(
        ".custom-slider-container:not(.is-ready):not(.is-slider-disabled)"
      ).forEach(function (c) {
        c.classList.add("is-slider-disabled");
      });
    }, 1500);
  }

  // rel="preload" のまま（onload未発火）+ rel="stylesheet"に変換済みの両方を収集
  const allStylePreloads = Array.from(
    document.querySelectorAll('link[as="style"]')
  );

  if (allStylePreloads.length === 0) {
    // 非同期CSSなし（例: 全インライン）→ 500ms後に解放
    setTimeout(releaseLock, 500);
    return;
  }

  let loaded = 0;
  let released = false;
  const total = allStylePreloads.length;

  function check() {
    loaded++;
    if (loaded >= total && !released) {
      released = true;
      releaseLock(); // CSS読み込み完了後即時解放（旧+500ms待機を削除・SI改善）
    }
  }

  allStylePreloads.forEach(function (link) {
    // 既にstylesheetとして適用済み（onload発火済みでrel変更 or sheet存在）
    if (link.rel !== "preload" || link.sheet) {
      check();
    } else {
      link.addEventListener("load", check, { once: true });
    }
  });

  // フォールバック: 800ms以内にCSSが読み込まれなければ強制解放（旧1.5秒→短縮・FCP改善）
  setTimeout(function () {
    if (!released) {
      released = true;
      releaseLock();
    }
  }, 800);
})();

// ==========================
// debounce：処理の実行を遅延させる（リサイズなどに使用）
// ==========================
const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};

// ==========================
// アコーディオンメニュー全対応（SPメニュー・汎用・単一） max-height アニメーション対応
// ==========================
function initAccordion() {
  const clickInterval = 100;
  let lastClickTime = 0;

  function toggleAccordion(title, single = false) {
    const acInner = title.nextElementSibling;
    if (!acInner || !acInner.classList.contains("ac_inner")) return;

    const now = Date.now();
    if (now - lastClickTime < clickInterval) return;
    lastClickTime = now;

    const isOpen = acInner.classList.contains("open");

    // レイアウト読み取りはスタイル変更より前に行う（Forced Reflow 防止）
    const targetHeight = isOpen ? null : acInner.scrollHeight;

    if (single) {
      document.querySelectorAll(".ac_title").forEach((otherTitle) => {
        const otherInner = otherTitle.nextElementSibling;
        if (otherInner && otherInner !== acInner && otherInner.classList.contains("ac_inner")) {
          otherInner.style.maxHeight = null;
          otherInner.classList.remove("open");
          otherTitle.classList.remove("open");
        }
      });
    }

    if (isOpen) {
      acInner.style.maxHeight = null;
      acInner.classList.toggle("open", !isOpen);
      title.classList.toggle("open", !isOpen);
    } else {
      requestAnimationFrame(function () {
        acInner.style.maxHeight = targetHeight + "px";
        acInner.classList.toggle("open", !isOpen);
        title.classList.toggle("open", !isOpen);
      });
    }
  }

  function addClickHandlers(selector, single = false) {
    document.querySelectorAll(selector).forEach((title) => {
      // 既存イベントを削除してから追加（クリーン登録）
      title.replaceWith(title.cloneNode(true));
    });

    document.querySelectorAll(selector).forEach((title) => {
      title.addEventListener("click", () => toggleAccordion(title, single));
    });
  }

  function adjustAccordion() {
    const ww = window.innerWidth;
    document.querySelectorAll(".ac_inner").forEach((acInner) => {
      if (ww > 1200) {
        acInner.style.maxHeight = "none";
        acInner.classList.add("open");
      } else {
        acInner.style.maxHeight = null;
        acInner.classList.remove("open");
      }
    });
  }

  function handleResize() {
    const ww = window.innerWidth;
    if (ww < 1200) {
      addClickHandlers(".ac_title_sp");
    } else {
      // PC時はアコーディオン開閉不要
    }
  }

  adjustAccordion();
  handleResize();
  addClickHandlers(".ac_title_sp");
  addClickHandlers(".ac_title_sa");
  addClickHandlers(".ac_title", true);

  window.addEventListener("resize", debounce(() => {
    adjustAccordion();
    handleResize();
  }, 100));
}

// ==========================
// TBT 軽減: 非クリティカルな初期化を requestIdleCallback で遅延・タスク分割
// ==========================
function runWhenIdle(callback, timeoutMs) {
  timeoutMs = timeoutMs || 2000;
  if (typeof requestIdleCallback !== "undefined") {
    requestIdleCallback(callback, { timeout: timeoutMs });
  } else {
    setTimeout(callback, 1);
  }
}
function runDeferredInitsWithYield(inits) {
  var i = 0;
  function next() {
    if (i < inits.length) {
      try {
        inits[i]();
      } catch (e) {}
      i++;
      setTimeout(next, 0);
    }
  }
  next();
}

document.addEventListener("DOMContentLoaded", function () {
  runWhenIdle(function () {
    runDeferredInitsWithYield([
      initAccordion,
      initTelLink,
      initPageTop,
      initImageSwitch,
      initCTAButtons,
      initFAQToggle,
    ]);
  }, 2000);
});

// ==========================
// スマホ用TELリンク変換
// ==========================
function initTelLink() {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  if (!isMobile) return;

  const telElements = document.querySelectorAll(".tel");
  if (!telElements.length) return;

  telElements.forEach((el) => {
    const text = el.innerHTML;
    const number = el.textContent.replace(/-/g, "");
    const anchor = document.createElement("a");
    anchor.href = `tel:${number}`;
    anchor.innerHTML = text;
    el.innerHTML = "";
    el.appendChild(anchor);
  });
}
// initTelLink は上記 runDeferredInitsWithYield で実行

// ==========================
// ページトップボタン表示・スクロール
// ==========================
function initPageTop() {
  const btn = document.getElementById("pagetop");
  if (!btn) return;

  const toggleBtnVisibility = () => {
    btn.style.display = window.scrollY > 100 ? "block" : "none";
  };

  btn.addEventListener("click", (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  window.addEventListener("scroll", toggleBtnVisibility);
  toggleBtnVisibility();
}
// initPageTop は runDeferredInitsWithYield で実行

// ==========================
// 画像のスマホ／PC自動切り替え
// ==========================
function initImageSwitch() {
  const images = document.querySelectorAll(".js-image-switch");
  if (!images.length) return;

  const sp = "_sp.";
  const pc = "_pc.";
  const breakpoint = 768;

  const switchImages = () => {
    const ww = window.innerWidth;
    images.forEach((img) => {
      const src = img.getAttribute("src");
      if (!src) return;
      if (ww >= breakpoint && src.includes(sp)) {
        img.setAttribute("src", src.replace(sp, pc));
      } else if (ww < breakpoint && src.includes(pc)) {
        img.setAttribute("src", src.replace(pc, sp));
      }
    });
  };

  // 強制リフロー対策: 初回のレイアウト読取（innerWidth）を次フレームにずらす
  requestAnimationFrame(switchImages);
  window.addEventListener("resize", debounce(switchImages, 200));
}
// initImageSwitch は runDeferredInitsWithYield で実行

// ==========================
// CTAボタンホバーアニメーション
// ==========================
function initCTAButtons() {
  const items = document.querySelectorAll(".cta_box__item");
  if (!items.length) return;

  items.forEach((item) => {
    const button = item.querySelector(".button-new");
    if (!button) return;

    item.addEventListener("mouseenter", () => {
      button.style.transform = "translateY(-10px)";
      // button.style.transition = "transform 0.3s ease";
    });
    item.addEventListener("mouseleave", () => {
      button.style.transform = "translateY(0)";
    });
  });
}
// initCTAButtons は runDeferredInitsWithYield で実行

// ==========================
// FAQトグル（開閉）処理
// ==========================
function initFAQToggle() {
  const headers = document.querySelectorAll(".toggle-block__header");
  if (!headers.length) return;

  headers.forEach((header) => {
    header.addEventListener("click", () => {
      const item = header.closest(".toggle-block__item");
      if (item) {
        item.classList.toggle("is-open");
      }
    });
  });
}
// initFAQToggle は runDeferredInitsWithYield で実行

// ----------------------------------------------

/* header-shrink-observer.js
   - リロード時の初期スクロール誤判定を抑止
   - IntersectionObserver の番兵で「本当に上端を離れたら」.is-small / .scroll_down を付与
   - CSS変数は使わず、SCSSで定義済みの height:112px/80px をそのまま利用
*/
(function () {
  'use strict';

  /** ====== 設定（必要に応じて変更） ====== */
  // あなたの md-layout のPC閾値に合わせてください（例：1201px以上がPC）
  var PC_MIN_WIDTH = 1201;

  // セレクタ
  var HEADER_SELECTOR = '#main_header';
  var MAIN_SELECTOR = '.main-new';

  // スマホ時のクラス付与制御
  var APPLY_SCROLL_DOWN_ON_SP = true; // ← スマホでも .scroll_down を付ける（デフォルトON）
  var APPLY_IS_SMALL_ON_SP    = false; // ← スマホでも .is-small を付けたいなら true

  // IOのしきい値（ヒステリシスが欲しければrootMarginを少しマイナスに）
  var OBSERVER_OPTIONS = { threshold: 0, rootMargin: '0px 0px 0px 0px' };

  /** ====== リロード復元スクロールの抑止（初期scrollY>0の誤判定対策） ====== */
  (function preventReloadRestore() {
    try {
      var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      if (nav && nav.type === 'reload' && 'scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
        window.scrollTo(0, 0);
      }
    } catch (_) { /* no-op */ }
  })();

  /** ====== 初期化（TBT 軽減のため requestIdleCallback で遅延） ====== */
  document.addEventListener('DOMContentLoaded', function () {
    var run = function () {
    var header = document.querySelector(HEADER_SELECTOR);
    var main = document.querySelector(MAIN_SELECTOR);
    if (!header || !main) return;

    var mqWide = window.matchMedia('(min-width: ' + PC_MIN_WIDTH + 'px)');

    // ヘッダー直後に“番兵”を置いて、上端から外れたかを検知
    var sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'position:relative;height:1px;margin-top:-1px;';
    header.insertAdjacentElement('afterend', sentinel);

    function applyClasses(isTop) {
      var isPC = mqWide.matches;

      if (isPC) {
        // PC：上端にいる間はクラスなし、外れたら付与
        header.classList.toggle('scroll_down', !isTop);
        header.classList.toggle('is-small', !isTop);
      } else {
        // SP：フラグに応じて制御
        if (APPLY_SCROLL_DOWN_ON_SP) {
          header.classList.toggle('scroll_down', !isTop);
        } else {
          header.classList.remove('scroll_down');
        }

        if (APPLY_IS_SMALL_ON_SP) {
          header.classList.toggle('is-small', !isTop);
        } else {
          header.classList.remove('is-small');
        }
      }
    }

    // 初期は“上端扱い”で安定化
    applyClasses(true);

    var io = new IntersectionObserver(function (entries) {
      var isTop = entries[0] && entries[0].isIntersecting;
      applyClasses(!!isTop);
    }, OBSERVER_OPTIONS);

    requestAnimationFrame(function () {
      try { io.observe(sentinel); } catch (_) {}
    });

    // リサイズ時：監視を付け直して現状反映
    window.addEventListener('resize', function () {
      try { io.unobserve(sentinel); } catch (_) {}
      applyClasses(window.scrollY === 0);
      requestAnimationFrame(function () {
        try { io.observe(sentinel); } catch (_) {}
      });
    });

    // bfcache復帰時（戻る/進む）
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        applyClasses(window.scrollY === 0);
      }
    });
    };
    if (typeof requestIdleCallback !== 'undefined') {
      requestIdleCallback(run, { timeout: 1500 });
    } else {
      setTimeout(run, 1);
    }
  });
})();


// スクロール＆ブレイクポイントでヘッダーサイズ変更
// document.addEventListener("DOMContentLoaded", function () {
//   var header = document.getElementById("main_header");
//   var main = document.querySelector(".main-new");
//   var navPos = header.offsetTop;

//   function updateHeader() {
//     var scrollPos = window.scrollY || document.documentElement.scrollTop;
//     var isWide = window.innerWidth > 1200;
//     var isScrolling = scrollPos > navPos || scrollPos > 0;
//     var height = isWide ? (isScrolling ? "72px" : "112px") : "72px";
//     var marginTop = isWide ? (isScrolling ? "72px" : "112px") : "72px";

//     if (isScrolling) {
//       header.classList.add("scroll_down"); // スクロール時にクラスを付与
//     } else {
//       header.classList.remove("scroll_down"); // スクロール時にクラスを削除
//     }

//     if (isWide && isScrolling) {
//       header.classList.add("is-small");
//     } else {
//       header.classList.remove("is-small");
//     }

//     header.style.height = height;
//     main.style.marginTop = marginTop;
//   }

//   function handleResize() {
//     var isWide = window.innerWidth > 1200;
//     if (!isWide) {
//       header.classList.remove("is-small");
//       header.style.height = "72px";
//       main.style.marginTop = "72px";
//     } else {
//       updateHeader();
//     }
//   }

//   // イベントリスナーを追加
//   window.addEventListener("scroll", updateHeader);
//   window.addEventListener("resize", handleResize);

//   // 初期読み込み時に実行
//   updateHeader();
// });

// ----------------------------------------------

// グローバルナビ スマホ表示切替え（ハンバーガーメニュー）
// defer の場合 DOMContentLoaded が既に発火していることがあるため readyState で即実行も行う
function initHamburgerNav() {
  var openbtn = document.querySelector(".openbtn");
  var headNav = document.querySelector(".head_nav");
  if (!openbtn || !headNav) return;

  function checkWidth() {
    // window.innerWidth は forced reflow を引き起こすため matchMedia に変更
    // matchMedia はレイアウトを強制クエリせずキャッシュ値を返す
    if (window.matchMedia("(min-width: 1200px)").matches) {
      openbtn.classList.remove("active");
      headNav.classList.remove("panelactive");
    }
  }

  window.addEventListener("resize", checkWidth);

  openbtn.addEventListener("click", function (e) {
    e.preventDefault();
    this.classList.toggle("active");
    headNav.classList.toggle("panelactive");
  });

  headNav.querySelectorAll("a").forEach(function (link) {
    link.addEventListener("click", function () {
      openbtn.classList.remove("active");
      headNav.classList.remove("panelactive");
    });
  });

  document.addEventListener("click", function (event) {
    if (event.target.closest(".follow-banner .close-btn")) return;
    if (!event.target.closest(".head_nav") && !event.target.closest(".openbtn")) {
      openbtn.classList.remove("active");
      headNav.classList.remove("panelactive");
    }
  });

  // Forced Reflow 対策: preventReloadRestore の scrollTo(0,0) でレイアウトが dirty になった
  // 直後に window.innerWidth を読むと強制リフローが発生するため rAF で次フレームに遅延する
  requestAnimationFrame(checkWidth);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initHamburgerNav);
} else {
  initHamburgerNav();
}

// ----------------------------------------------
// 装飾背景の遅延読み込み（LCP・転送量軽減。ビューポート進入時に background-image を付与）
// ----------------------------------------------
function initLazyDecorBg() {
  var elements = document.querySelectorAll("[data-bg-decor]");
  if (!elements.length) return;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var url = el.getAttribute("data-bg-decor");
        if (url) {
          el.style.backgroundImage = "url(" + url + ")";
          el.removeAttribute("data-bg-decor");
        }
        observer.unobserve(el);
      });
    },
    { rootMargin: "150px" }
  );
  elements.forEach(function (el) {
    observer.observe(el);
  });
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initLazyDecorBg);
} else {
  initLazyDecorBg();
}

// ----------------------------------------------

// アコーディオン開閉処理（アニメーション付き、開発ツール対策付き）
// document.addEventListener("DOMContentLoaded", function () {
//   const clickInterval = 100;
//   let lastClickTime = 0;

//   function adjustAccordion() {
//     const windowWidth = Math.floor(window.innerWidth);
//     document.querySelectorAll(".ac_inner").forEach((acInner) => {
//       if (windowWidth > 1200) {
//         acInner.style.maxHeight = "none";
//       } else {
//         acInner.style.maxHeight = null;
//         acInner.classList.remove("open");
//       }
//     });
//   }

//   function toggleAccordion(title, single = false) {
//     const acInner = title.nextElementSibling;
//     if (!acInner || !acInner.classList.contains("ac_inner")) return;

//     const isOpen = acInner.classList.contains("open");
//     const currentTime = Date.now();
//     if (currentTime - lastClickTime < clickInterval) return;
//     lastClickTime = currentTime;

//     if (single) {
//       document.querySelectorAll(".ac_title").forEach((otherTitle) => {
//         const otherInner = otherTitle.nextElementSibling;
//         if (otherInner && otherInner.classList.contains("ac_inner") && otherInner !== acInner) {
//           otherInner.style.maxHeight = null;
//           otherInner.classList.remove("open");
//           otherTitle.classList.remove("open");
//         }
//       });
//     }

//     if (isOpen) {
//       acInner.style.maxHeight = null;
//     } else {
//       acInner.style.maxHeight = acInner.scrollHeight + "px";
//     }
//     acInner.classList.toggle("open", !isOpen);
//     title.classList.toggle("open", !isOpen);
//   }

//   function addClickHandler(selector, single = false) {
//     document.querySelectorAll(selector).forEach((title) => {
//       title.addEventListener("click", (e) => {
//         if (!e.isTrusted) return; // 開発ツール操作を無視
//         toggleAccordion(title, single);
//       });
//     });
//   }

//   function addCloseHandler(selector, titleSelector = null) {
//     document.querySelectorAll(selector).forEach((btn) => {
//       btn.addEventListener("click", (e) => {
//         if (!e.isTrusted) return;
//         const acInner = btn.closest(".ac_inner");
//         if (!acInner) return;
//         acInner.style.maxHeight = null;
//         acInner.classList.remove("open");
//         if (titleSelector) {
//           const title = acInner.previousElementSibling;
//           if (title && title.classList.contains(titleSelector)) {
//             title.classList.remove("open");
//           }
//         } else {
//           document.querySelectorAll(".ac_title").forEach((t) => t.classList.remove("open"));
//         }
//       });
//     });
//   }

//   function handleResize() {
//     const windowWidth = Math.floor(window.innerWidth);
//     if (windowWidth < 1200) {
//       addClickHandler(".ac_title_sp");
//     } else {
//       document.querySelectorAll(".ac_title_sp").forEach((title) => {
//         title.classList.remove("open");
//         const newTitle = title.cloneNode(true);
//         title.replaceWith(newTitle); // イベント削除
//       });
//     }
//   }

//   function debounce(func, wait) {
//     let timeout;
//     return function (...args) {
//       clearTimeout(timeout);
//       timeout = setTimeout(() => func.apply(this, args), wait);
//     };
//   }

//   // 初期処理
//   adjustAccordion();
//   handleResize();

//   // リサイズ時
//   window.addEventListener(
//     "resize",
//     debounce(() => {
//       adjustAccordion();
//       handleResize();
//     }, 100)
//   );

//   // 各種開閉イベント登録
//   addClickHandler(".ac_title_sp");
//   addClickHandler(".ac_title_sa");
//   addClickHandler(".ac_title", true); // 一つのみ開く

//   addCloseHandler(".ac_close_sp", "ac_title_sp");
//   addCloseHandler(".ac_close_sa", "ac_title_sp");
//   addCloseHandler(".ac_close");

//   // CSSが必要：
//   // .ac_inner {
//   //   overflow: hidden;
//   //   max-height: 0;
//   //   transition: max-height 0.3s ease;
//   // }
//   // .ac_inner.open {
//   //   max-height: 1000px; // or transition with scrollHeight
//   // }
// });

// ----------------------------------------------

// titleタグからhtmlタグ削除（TBT 軽減のため遅延）
document.addEventListener("DOMContentLoaded", function () {
  runWhenIdle(function () {
    var titleElement = document.querySelector("title");
    if (titleElement) {
      var titleText = titleElement.textContent;
      titleText = titleText.replace(/<.+?>/g, "");
      titleElement.textContent = titleText;
    }
  }, 1500);
});

// ----------------------------------------------

// タブ切り替え（TBT 軽減のため遅延）
document.addEventListener("DOMContentLoaded", function () {
  runWhenIdle(function () {
  const tabs = document.querySelectorAll(".tab-container .tab");
  const contents = document.querySelectorAll(".tab-content-container .content");

  tabs.forEach((tab, index) => {
    tab.addEventListener("click", function () {
      // すべてのタブから-activeクラスを削除
      document.querySelector(".tab-container .-active")?.classList.remove("-active");
      // クリックされたタブに-activeクラスを追加
      tab.classList.add("-active");

      // すべてのコンテンツから-showクラスを削除
      contents.forEach((content) => content.classList.remove("-show"));
      // 対応するコンテンツに-showクラスを追加
      contents[index].classList.add("-show");
    });
  });
  }, 1500);
});

// ----------------------------------------------

/**
 * スムーススクロール制御（別ページリンク時に一旦ページトップに戻す）
 */
(function () {
  // 停止位置調整用：header + .navi_tab の高さを取得
  function getAdjustHeight() {
    var header = document.getElementById("main_header");
    var naviTab = document.querySelector(".navi_tab");
    var adjust = 0;
    if (header) adjust += header.offsetHeight;
    if (naviTab) adjust += naviTab.offsetHeight;
    return adjust;
  }

  // スムーススクロール（強制リフロー対策: レイアウト読取を二重 rAF で次々フレームにずらす）
  function smoothScrollToTarget(target) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var adjust = getAdjustHeight();
        var rect = target.getBoundingClientRect();
        var targetTop = rect.top + window.pageYOffset - adjust;

        window.scrollTo({
          top: targetTop,
          behavior: "smooth"
        });
      });
    });
  }

  // ページ読み込み前に一時的にハッシュを除去（ブラウザの自動スクロール抑止）
  if (location.hash) {
    // ハッシュ部分を退避
    var hash = location.hash;

    // 一旦ハッシュを除去（ブラウザの自動ジャンプを防ぐ）
    history.replaceState(null, null, location.pathname + location.search);

    // ページ読み込み後に改めてスムーススクロール
    window.addEventListener("load", function () {
      // ページトップに戻す
      window.scrollTo(0, 0);

      // 0.2秒後にハッシュ戻し → スムーススクロール
      setTimeout(function () {
        // ハッシュを戻す（アドレスバー更新用）
        history.replaceState(null, null, location.pathname + location.search + hash);

        var target = document.querySelector(hash);
        if (target) {
          smoothScrollToTarget(target);
        }
      }, 200);
    });
  }

  // 同ページ内リンク・グローバルナビリンクも対応（TBT 軽減のため遅延）
  document.addEventListener("DOMContentLoaded", function () {
    if (typeof runWhenIdle !== "undefined") {
      runWhenIdle(function () {
        document.querySelectorAll('a[href*="#"]').forEach(function (anchor) {
          anchor.addEventListener("click", function (event) {
        var linkUrl = new URL(anchor.href, location.href);

        // 同ページか判定
        if (linkUrl.pathname === location.pathname) {
          var target = document.querySelector(linkUrl.hash);
          if (target) {
            event.preventDefault();
            smoothScrollToTarget(target);
          }
        }
      });
    });
      }, 1500);
    } else {
      document.querySelectorAll('a[href*="#"]').forEach(function (anchor) {
        anchor.addEventListener("click", function (event) {
          var linkUrl = new URL(anchor.href, location.href);
          if (linkUrl.pathname === location.pathname) {
            var target = document.querySelector(linkUrl.hash);
            if (target) {
              event.preventDefault();
              smoothScrollToTarget(target);
            }
          }
        });
      });
    }
  });
})();
